// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router'
import VueCarousel from 'vue-carousel';
import * as VueGoogleMaps from 'vue2-google-maps'
import VueHead from 'vue-head'
Vue.use(VueHead);

window.$ = require('jquery');
window.jQuery = require('jquery');


Vue.config.productionTip = false;

Vue.use(VueCarousel);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBWMEZYVrdpkhUG6RPDaXf53UBIX6LMgRo',
    libraries: 'places',
  }
});



export const PATH = 'https://admin.nossa.pt/';
export const CACHE = false;



export const axios = require('axios').default;

let SITE_DATA = [];
let PROJ_DATA = [];



export function WP(afc, call){

  let hasObj = false;
  let acfObj = {};

  for (let i = 0; i < SITE_DATA.length; i++){

    if(SITE_DATA[i].name === call){
      hasObj = true;
      acfObj = SITE_DATA[i].resp;
    }

  }

  if(hasObj){
    call(acfObj)
    console.log(SITE_DATA)
  }else{
    ajaxA(afc, call)
  }


 // ajaxA(afc, call)
}


export function sendEmail (obj, call){
  $.ajax({
    type: "POST",
    //url:  'https://nossavisao.pt/avaliacoes/wp-content/plugins/nossa-mailer/sendmail.php',
    url:  'https://nossavisao.pt/avaliacoes/wp-content/plugins/nossa-mailer/sendmail2.php',
    //  data:  JSON.stringify(dataJSON),
    data: obj,
    // dataType: 'json',
    success: function(data){

      //  console.log(data)
      let dt  = data.toString();
      let arr = dt.split('<br>');
      let resp = '';
      let resp2= '';
      Array.prototype.forEach.call(arr, function (item, index, boda) {
        //console.log(item.trim(), index, boda.length)
        resp = Boolean(item.trim());
        resp2 = item.trim();
      });
      call(resp)
    }
  });
}

export function addData (obj, call){
  $.ajax({
    type: "POST",
    url:  PATH +'wp-json/nossa-api/add/',
    //  data:  JSON.stringify(dataJSON),
    data: obj,
    dataType: 'json',
    success: function(data){
      call(data);
    }
  });
}

function ajaxA(afc, call){


  // Make a request for a user with a given ID
  axios.get( PATH +'wp-json/nossa-api/data/' + afc)
      .then(function (response) {
        // handle success
      //  console.log(response);

        SITE_DATA.push({name: afc, resp: response.data});
        //console.log(SITE_DATA)
        call(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
      });
}

function ajaxJ(afc, call){
  jQuery.support.cors = true;
  $.ajax ({

    url:        PATH +'wp-json/nossa-api/data/' + afc,
    type:        'GET',
    cache: false,
    async: true,
    dataType: "json",
    success: function (response) {

      SITE_DATA.push({name: afc, resp: response});
     //console.log(SITE_DATA)
      call(response);

    },
  });
}



export function PROJ(mode,afc, call){
  let hasObj = false;
  let acfObj = {};

  for (let i = 0; i < PROJ_DATA.length; i++){

    if(PROJ_DATA[i].name === call){
      hasObj = true;
      acfObj = PROJ_DATA[i].resp;
    }

  }

  if(hasObj){
    call(acfObj)
    console.log('PROJ_DATA',PROJ_DATA);
  }else{
    ajaxProj(mode,afc, call)
  }

}
function ajaxProj(mode,afc, call){


  let _path = '';

  if(mode === 'id'){
    _path = PATH +'wp-json/nossa-api/proj/' + afc;
  }else{
    _path = PATH +'wp-json/nossa-api/proj-by-route/' + afc;
  }


  axios.get( _path)
      .then(function (response) {
        // handle success


        PROJ_DATA.push({name: afc, resp: response.data});



        call(response.data);
      })
      .catch(function (error) {
        // handle error
       // console.log(error);
      })
      .then(function () {
        // always executed
      });

  /*

  jQuery.support.cors = true;

  $.ajax ({

    url:         _path,
    type:        'GET',
    cache: false,
    async: true,
    dataType: "json",
    success: function (response) {

      call(response);

    },
  });

   */
}


export function HTML(afc, call){
  jQuery.support.cors = true;
  $.ajax ({

    url:         PATH +'/2021/11/04/blog/',
    type:        'GET',
    cache: false,
    async: true,

    success: function (response) {

      call(response);

    },
  });
}

Vue.config.productionTip = false;

const EVENTBUS = new Vue();
export {EVENTBUS };


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'

})


window.abc = function(){
  console.log('abc');
}


export function getExtension(str){

  let arr = str.split(".");

  return 'image/' + arr[arr.length-1];

}




export function testInsert(){


  /*

  // Make a request for a user with a given ID
  axios.post( PATH +'wp-json/nossa-api/insert', {
    id: 11,
    name: "Tom Brady",
    username: "Brad",
    email: "tombrad@asd.com",
  })
      .then(function (response) {
        // handle success
          console.log('insert');
          console.log(response);


      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
      });


*/





  jQuery.support.cors = true;
  $.ajax ({

    url:         PATH +'wp-json/nossa-api/insert',
    type:        'POST',
    cache: false,
    async: true,
    data: {
      name: "Donald Duck",
      logo: "Duckburg",
      link: "link"
    },

    success: function (response) {

      console.log(response);


    },
  });


}



let hasClicksV = false;

export function hasClicks(){

  return hasClicksV;

}

export function setClicks(){

  hasClicksV = true;
}



let deskProj = {}
export function setDeskProj(o){
  deskProj = o;
}

export function getDeskProj(){
  return deskProj;
}


// WEBPACK FOOTER //
// ./src/main.js